<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512"
>
  <path
    d="M454.428 38.028c-19.529-19.529-51.342-19.53-70.871 0l-368.91 368.91c-19.529 19.529-19.529 51.343 0 70.871s51.343 19.529 70.871 0l368.91-368.911c19.528-19.529 19.528-51.342 0-70.87z"
    style="fill: #806749"
  />
  <path
    d="M14.682 477.842c19.532 19.494 51.318 19.483 70.836-.033l368.91-368.911c19.517-19.517 19.527-51.303.035-70.834l-.003.001L14.684 477.839l-.002.003z"
    style="fill: #5f4d37"
  />
  <path
    d="M343.877 8.229c-6.525-6.525-17.096-6.525-23.621 0l-78.743 78.737a16.712 16.712 0 0 0-4.893 11.81c0 4.427 1.762 8.678 4.893 11.81l91.255 91.265a15.852 15.852 0 0 0 2.088 3.001c3.507 3.937 6.868 8.058 10.223 12.159 60.814 76.594 84.31 175.592 64.42 271.556a16.7 16.7 0 0 0 8.988 18.379 16.544 16.544 0 0 0 7.362 1.718c4.753 0 9.424-2.033 12.681-5.819 87.65-102.064 104.058-260.26 9.815-386.48-15.11-20.234-41.029-44.687-104.468-108.136z"
    style="fill: #e0e0e2"
  />
  <path
    d="M281.291 47.793 241.82 87.262c-3.133 3.133-4.894 7.384-4.894 11.81s1.762 8.678 4.894 11.81c76.197 76.205 209.075 179.739 167.985 377.981a16.7 16.7 0 0 0 8.988 18.379c.063.031.131.039.195.069 118.631-245.62-96.793-417.565-137.697-459.518z"
    style="fill: #c6c5ca"
  />
</svg>
